import i18n from 'i18next';

export function getOrdinalSuffix(day: number, locale: string): string {
    if (locale.startsWith('en')) {
        if (day > 3 && day < 21) return 'th';
        switch (day % 10) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
        }
    }
    return '';
}

export function formatAmsterdamDate(dateString: string, locale: string = i18n.language || 'nl'): string {
    const date = new Date(dateString); // ✅ Correct fix

    const formatter = new Intl.DateTimeFormat(locale, {
        timeZone: 'Europe/Amsterdam',
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    });

    const parts = formatter.formatToParts(date); // ✅ Use the Date object

    const weekday = parts.find(p => p.type === 'weekday')?.value;
    const day = parts.find(p => p.type === 'day')?.value;
    const month = parts.find(p => p.type === 'month')?.value;
    const year = parts.find(p => p.type === 'year')?.value;

    const ordinal = getOrdinalSuffix(parseInt(day || '0'), locale);

    if (locale.startsWith('nl')) {
        return `${weekday} ${day} ${month} ${year}`;
    }

    return `${weekday} ${day}${ordinal}, ${month} ${year}`;
}
